import { useMemo } from 'react';

import { isNil } from 'lodash';

import { CheckoutApartmentInfo } from '@app/components/molecules/checkout-apartment-info';
import { ForeignPartnerId } from '@app/enums';
import { apiTypes } from '@app/models';

import { AccommodationDetailsProps } from './accommodation-details.props';

export const AccommodationDetails = ({
    accommodationDetails,
    reservationSummary,
    ...rest
}: AccommodationDetailsProps) => {
    const isEmpty = useMemo(
        () => isNil(accommodationDetails) || !accommodationDetails?.apartments?.length,
        [accommodationDetails],
    );

    if (isEmpty && !reservationSummary) {
        return null;
    }

    const isAvantioAccommodation =
        accommodationDetails?.foreignPartnerId === ForeignPartnerId.avantio;

    return (
        <>
            {reservationSummary &&
                !!accommodationDetails?.apartments?.length &&
                accommodationDetails?.apartments &&
                (accommodationDetails?.apartments as apiTypes.Apartment[]).map(
                    (apartment: apiTypes.Apartment) => {
                        const { name, id, size, images } = apartment;
                        const provision = {
                            type: reservationSummary?.provisionTypeId,
                            name: reservationSummary?.provisionType,
                        };

                        return (
                            <CheckoutApartmentInfo
                                key={id}
                                name={name}
                                adultCount={reservationSummary?.adultCount || 1}
                                childrenCount={(reservationSummary?.childAges || []).length}
                                apartmentId={id}
                                provision={
                                    (provision as apiTypes.Variant['provision']) ?? undefined
                                }
                                guarantee={{
                                    // add hoc fix (seems like there is a new required field in Guarantee type)
                                    cancellationTexts: '',
                                    description:
                                        reservationSummary?.cancellation
                                            ?.reservationCancellationText,
                                }}
                                size={size ?? undefined}
                                roomImageSrc={images?.[0]?.url}
                                prepayment={reservationSummary?.prepayment ?? undefined}
                                fullConvertedPrice={
                                    reservationSummary.convertedPrice?.price ?? undefined
                                }
                                isAvantioAccommodation={isAvantioAccommodation}
                            />
                        );
                    },
                )}

            {!reservationSummary &&
                accommodationDetails?.apartments &&
                (accommodationDetails?.apartments as apiTypes.Apartment[]).map(
                    (apartment: apiTypes.Apartment) => {
                        const { name, id, size, images } = apartment;

                        return (apartment.variants as apiTypes.Variant[]).map(variant => (
                            <CheckoutApartmentInfo
                                name={name}
                                adultCount={variant?.guests || 1}
                                childrenCount={(variant?.childrenAges || []).length}
                                apartmentId={id}
                                guarantee={variant?.ratePlan.guarantee}
                                provision={variant?.provision}
                                ratePlanId={variant?.ratePlan.id}
                                size={size ?? undefined}
                                key={id}
                                roomImageSrc={images?.[0]?.url}
                                isAvantioAccommodation={isAvantioAccommodation}
                            />
                        ));
                    },
                )}
        </>
    );
};
